import PropTypes from "prop-types"
import React, { useEffect } from "react"

/**
 * Embeds a Bluesky post.
 *
 * Similar to the "Threads" oEmbed issue, we cannot rely on Bluesky's oEmbed API since they lack
 * CORS headers.
 *
 * See https://github.com/bluesky-social/social-app/issues/7311
 *
 * Instead, we're using the Bluesky embed script directly.
 */
const BlueskyEmbed = ({ uri }) => {
  /**
   * Bluesky does not continuously scan for `[data-bluesky-uri]` elements, which is great thinking
   * for performance on their side.
   *
   * However, we need to manually trigger a scan when the component mounts when previewing drafts,
   * otherwise we won't see Bluesky embeds.
   *
   * Their `scan` function is idempotent, so it's safe to call it multiple times.
   */
  useEffect(() => {
    window.bluesky?.scan()
  }, [])

  if (!document.getElementById("injected-bluesky-embed")) {
    const scriptElement = document.createElement("script")
    scriptElement.id = "injected-bluesky-embed"
    scriptElement.async = true
    scriptElement.src = "https://embed.bsky.app/static/embed.js"
    document.body.appendChild(scriptElement)
  }

  return <blockquote className="bluesky-embed" data-bluesky-uri={uri}></blockquote>
}

export default BlueskyEmbed

BlueskyEmbed.propTypes = {
  uri: PropTypes.string,
}
